<template>
  <div class="allGoods">
    <section class="Title">
      <p class="TitleBorder"></p>
      <p class="TitleName">{{ $t.cStore.allProducts }}</p>
    </section>
    <div class="rowBox">
      <van-row>
        <van-col span="12" v-for="(item, index) in allProducts" :key="index">
          <div class="productBox">
            <div class="product">
              <figure
                class="productImg"
                @click="getProductDetails(item.ProductNumber)"
              >
                <img class="ImgIcon" :src="imgUrlFilter(item.ProductPhoto)" />
              </figure>
              <h3
                class="productTitle"
                @click="getProductDetails(item.ProductNumber)"
              >
                {{ item.ProductName }}
              </h3>
              <section
                class="info"
                @click="getProductDetails(item.ProductNumber)"
              >
                <p class="unit">$</p>
                <p class="num">{{ item.CurrentPrice }}</p>
                <p class="sale">{{ item.Sales }}{{ $t.cStore.sold }}</p>
              </section>
            </div>
          </div>
        </van-col>
      </van-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "AllGoods",
  props: ["allProducts"],
  data() {
    return {};
  },
  methods: {
    imgUrlFilter(value) {
      //console.log(value.split("|")[0]);
      return this.$api.formatImageUrl(value.split("|")[0]);
    },
    //跳转详情页
    getProductDetails(ProductNumber) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "details",
        name: "details",
        query: [
          {
            name: "productNumber",
            value: ProductNumber,
          },
        ],
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/publicStyle.scss";
@mixin publicProduct {
  width: 96%;
  text-align: center;
  border-radius: 16px;
  box-shadow: 0 0 0px 1px #ece7e7;
  background-color: #ffffff;
  margin-right: 4%;
}
@mixin productInfo {
  padding: 0;
  margin: 0;
  text-align: center;
  @include spanNowrap;
}
.allGoods {
  width: 100%;
  .Title {
    @include publicFlex;
    .TitleBorder {
      margin: 0;
      padding: 0;
      height: 10px;
      width: 30px;
      border-radius: 20px;
      background-color: #0090e6;
      transform: rotate(90deg);
      -webkit-transform: rotate(90deg);
    }
    .TitleName {
      margin: 0;
      padding: 0;
      font-size: 30px;
      color: #000000;
    }
  }
  .rowBox {
    width: 100%;
    margin: 0 auto;
    ::v-deep .van-row {
      .van-col {
        margin-top: 30px;
        &:nth-child(even) {
          .productBox {
            .product {
              // background-color: red;
              @include publicProduct;
              margin-left: 4%;
            }
          }
        }
        &:nth-child(odd) {
          .productBox {
            .product {
              // background-color: red;
              margin: 0;
              @include publicProduct;
              margin-right: 4%;
            }
          }
        }
      }
    }
    .productBox {
      width: 100%;
      position: relative;
      // background-color: #ffffff;
      background-color: #f6f6f6;
      .productImg {
        margin: 0;
        padding: 0;
        width: 100%;
        height: 0;
        padding-bottom: 85%;
        overflow: hidden;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        .ImgIcon {
          width: 100%;
          height: 266px;
          object-fit: cover;
          -webkit-object-fit: cover;
          border-top-left-radius: 20px;
          border-top-right-radius: 20px;
        }
      }
      .productTitle {
        margin: 18px auto;
        padding: 0;
        width: 90%;
        font-size: 14px;
        line-height: 30px;
        height: 50px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .info {
        width: 90%;
        margin: 0 auto;
        display: flex;
        display: -webkit-flex;
        align-items: center;
        -webkit-align-items: center;
        padding-bottom: 18px;
        .unit {
          @include productInfo;
          font-size: 24px;
          color: #ff5852;
          width: 8%;
          font-weight: bold;
        }
        .num {
          @include productInfo;
          color: #ff5852;
          font-weight: bold;
          font-size: 40px;
          width: 42%;
        }
        .sale {
          @include productInfo;
          color: #a7a7a7;
          text-align: center;
          font-size: 23px;
          width: 50%;
        }
      }
    }
  }
}
</style>
